import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { dpiaGridPageRoutes, prefetchDpiaGridViewAndForm } from "./DpiaGridPage";

export const route: NavigationItemType["route"] = { path: "dpia", children: dpiaGridPageRoutes };
export const to = (paths: Paths) => paths.dpiaGrid();
export const prefetch = () => prefetchDpiaGridViewAndForm();
